/**
 * 二手车品牌车系车型
 */
export default function usedCarVehicleBrandAndSerial({
    vehicleBrand = '',
    vehicleSerial = '',
    vehicleType = '',
    vehicleModel = '',
    vehicleSeries = '',
}) {
    const type = vehicleType || vehicleModel;
    const serial = vehicleSerial || vehicleSeries;
    if (!vehicleBrand && !serial && !type) return '--';
    return `${`${vehicleBrand } ` || ''}${`${serial } ` || ''}${type || ''}`;
}
